import cn from 'classnames';
import { FC } from 'react';

import styles from './ModalHeader.module.scss';
import { Row } from '../../FormModule/components/Row';

interface IModalHeaderProps {
  title?: string;
  size?: 'small' | 'large';
  sizeText?: 'small' | 'medium';
  color?: 'black';
  weight?: 'bold';
  placement?: 'centre';
  type?: 'additional' | 'small';
}

export const ModalHeader: FC<IModalHeaderProps> = ({
  children,
  title,
  size,
  sizeText,
  color,
  weight,
  placement,
  type,
}) => {
  return (
    <header
      className={cn(styles.Header, {
        [styles.HeaderLarge]: size === 'large',
        [styles.HeaderCentre]: placement === 'centre',
        [styles.HeaderAdditional]: type === 'additional',
        [styles.HeaderSmall]: type === 'small',
      })}
    >
      {title ? (
        <Row>
          <span
            className={cn(styles.Title, {
              [styles.TitleSmall]: sizeText === 'small',
              [styles.TitleMedium]: sizeText === 'medium',
              [styles.TitleBlack]: color === 'black',
              [styles.TitleBold]: weight === 'bold',
            })}
          >
            {title}
          </span>
        </Row>
      ) : (
        children
      )}
    </header>
  );
};
